<!--
// FOR VNEXT-1726
// DROP DOWN FIELDS CAN NO LONGER BE SELECTED IN THE FORM BUILDER
// Existing uses of it remain and function, you just can't create a new one in Forms Templates anymore
// FLEX FIELDS ARE NOW TO BE USED FOR ALL MULTI-SELECT FUNCTIONALITY
-->

<ng-template #instructionsTemplate><ng-content select="[projectedInstructions]"></ng-content></ng-template>
<ng-template #tooltipTemplate><ng-content select="[projectedTooltip]"></ng-content></ng-template>

<!--*ngIf="(this.Mode === 'design') || (this.Mode === 'preview') || (this.Mode === 'instance')"-->
@if (this.ReadyToRender) {
  <div class="design-mode-outer-div">
    @if (this.UsesMainFieldLabel && !FieldIsInGrid) {
      <div class="{{this.Mode =='design' ? 'design-mode-field-label' : 'field-label'}}">
        {{this.DisplayName}}
        @if (this.FormField.required) {
          <span style="color: #EF0000;">*</span>
        }
      </div>
    }
    <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
    <!-- If we do not have a configuration, give the user a hint. -->
    @if (this.DisplayConfigTip) {
      <div
        class="no-config-div">
        <p class="user-tip-p">Use properties to load options from a CSV file</p>
      </div>
    }
    <!-- If we have a configuration, display it. -->
    @if ((!this.DisplayConfigTip) && (this.DropDownHeaders !== null)) {
      <div
        [ngClass]="this.IsHorizontal ? 'flex-direction-row' : 'flex-direction-column'">
        @for (dropDownHeader of this.DropDownHeaders; track dropDownHeader; let i = $index) {
          <div
            [ngClass]="this.IsHorizontalAndNotFirstSelection(i) ? 'flex-row-top-right flex-grow-one margin-left-10px' : 'flex-row-top-right flex-grow-one'">
            <div class="fill-remaining-space">
              <mat-form-field appearance="outline"
                class="dropdown-mat-form-field"
                style="{{this.AdditionalMatFormFieldStyles}}">
                @if ( !FieldIsInGrid) {
                  <mat-label>{{dropDownHeader}}</mat-label>
                }
                <mat-select [disabled]="this.ReadOnly || this.HeaderSelectionDisabled(i + this.HeaderIndexOffset, dropDownHeader)"
                  [(ngModel)]="this.DropDownValues[i + this.HeaderIndexOffset]"
                  (ngModelChange)="this.dropDownValueChanged(i + this.HeaderIndexOffset)"
                  (selectionChange)="this.handleOnModelChange()">
                  <mat-option title="Select {{dropDownHeader}}" [value]="0">
                    -- Select {{dropDownHeader}}--
                  </mat-option>
                  @for (hshOption of this.DropDownOptionsForHeader(i + this.HeaderIndexOffset); track hshOption) {
                    <mat-option
                      title="{{this.getSelectedValue(hshOption.ValueText, hshOption.Index, i)}}"
                      [value]="hshOption.Index">
                      {{this.getSelectedValue(hshOption.ValueText, hshOption.Index, i)}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            @if (i == 0) {
              <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
            }
          </div>
        }
      </div>
    }
    <!-- If we have an error, display it. -->
    @if (this.Error !== null) {
      <div
        class="error-div">
        <span>{{this.Error}}</span>
      </div>
    }
  </div>
}
